import { useSelector } from "react-redux";
import { getTotalConcurrents } from "../../features/concurrents/concurrentsSlice";
import { getTotalUsers } from "../../features/users/manageUsersSlice";
import { selectTotal } from "../../features/websites/websitesSlice";

/**
 * GUARD SUBSCRIPTION USER (POLICIES SUBSCRIPTION)
 */
export function useSubscriptionGard() {
  const totalWebsites = useSelector(selectTotal)
  const totalCompetitors = useSelector(getTotalConcurrents)
  const totalUsers = useSelector(getTotalUsers)
  const subscribe = useSelector(
    /**
     * 
     * @param {{subscriptions: {products: Product[], product: Product | null }}} state 
     */
    state => state.subscriptions.product
  )

  const can = {
    addWebsites: true,
    addCompetitors: true,
    addUsers: true,
  }

  if (!subscribe?.limits) return {
    websites: {
      canAdd: !can.addWebsites,
      rest: 0
    },
    competitors: {
      canAdd: !can.addCompetitors,
      rest: 0
    },
    users: {
      canAdd: !can.addUsers,
      rest: 0
    }
  }

  /**
   * @type {{websites: number, competitors: number, users: number}}
   */
  const limit = JSON.parse(subscribe.limits)

  if (totalWebsites >= limit.websites) can.addWebsites = false
  else can.addWebsites = true
  if (totalCompetitors >= limit.competitors) can.addCompetitors = false
  else can.addCompetitors = true
  if (totalUsers >= limit.users) can.addUsers = false
  else can.addUsers = true

  return {
    websites: {
      canAdd: can.addWebsites,
      rest: limit.websites - totalWebsites,
      limit: limit.websites
    },
    competitors: {
      canAdd: can.addCompetitors,
      rest: limit.competitors - totalCompetitors,
      limit: limit.competitors

    },
    users: {
      canAdd: can.addUsers,
      rest: limit.users - totalUsers,
      limit: limit.users
    }
  }
}